import React from 'react';
import { useSelector } from 'react-redux';
import Scroll from 'react-scroll';
import withStyles from 'isomorphic-style-loader/withStyles';
import Button from 'react-bootstrap/lib/Button';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';

import messages from '../../locale/messages';
import history from '../../core/history';

import { DoubleArrowIcon } from '../../components/Common/Assets/SvgComponent/commonSvgIcon';

import s from './WhyHostBanner.css';
import bt from '../../components/commonStyle.css';

// Or Access Link,Element,etc as follows
let Link = Scroll.Link;

const WhyHostBanner = ({ data }) => {

    const isAuthenticated = useSelector(state => state.runtime.isAuthenticated);

    const handleClick = () => {
        if (isAuthenticated) {
            history.push('/become-a-host?mode=new');
        } else {
            history.push('/login?refer=/become-a-host?mode=new');
        }
    }

    return (
        <div className={cx(s.grid, 'commonWordBreak')}>
            <div className={s.bannerText}>
                <h1 className={s.bannerTitle}>
                    {data && data.hostBannerTitle1}
                </h1>
                <div className={cx(s.whyHostBtnFlex)}>
                    <Button className={cx(bt.btnPrimary, s.borderRadius)} onClick={handleClick}>
                        <FormattedMessage {...messages.becomeAHost} />
                    </Button>
                    <Link
                        className={cx(bt.btnPrimaryBorder, s.borderRadius, s.whyHostLearnMoreBtn)}
                        activeClass={s.active}
                        to="test1"
                        spy={true}
                        smooth={true}
                        offset={1} duration={1}
                    >
                        <FormattedMessage {...messages.learnMore} />
                        <DoubleArrowIcon className={s.learnIcon} />
                    </Link>
                </div>
            </div>
            <div className={s.TopBannerHeader} style={{ backgroundImage: `url(/images/home/${data && data.hostBannerImage1})` }} ></div>
        </div>
    );
}

WhyHostBanner.defaultProps = {
    isAuthenticated: false
};

export default withStyles(s, bt)(WhyHostBanner);